/**
 * Whether the reader is on a Mac, iPhone or iPad — the only places Apple's own wording (FaceTime, the
 * Apple Calendar button) is offered (owner, 28 October 2026). Never used to hide or alter a link that
 * exists: a FaceTime link opens in any browser as a guest. Pure.
 */

export interface NavigatorLike {
  readonly userAgent: string;
  /** User-Agent Client Hints; absent outside Chromium, and its `platform` may be blank. */
  readonly userAgentData?: { readonly platform?: string };
}

export function isApplePlatform(navigator: NavigatorLike | undefined): boolean {
  if (navigator === undefined) return false;
  const platform = navigator.userAgentData?.platform;
  if (platform !== undefined && platform !== '') return platform === 'macOS' || platform === 'iOS';
  // iPadOS asks for the desktop page and reads Macintosh: an Apple device all the same.
  return /Macintosh|iPhone|iPad/.test(navigator.userAgent);
}
